import { render, staticRenderFns } from "./btnDescarga.vue?vue&type=template&id=6048d7bf&scoped=true"
import script from "./btnDescarga.vue?vue&type=script&lang=js"
export * from "./btnDescarga.vue?vue&type=script&lang=js"
import style0 from "./btnDescarga.vue?vue&type=style&index=0&id=6048d7bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6048d7bf",
  null
  
)

export default component.exports